import React from "react";

const Service = () => {
  const data = [
  {
    syntax: "TB <SDT1> <SDT2>…",
    feature:
      "• Đăng ký để sử dụng tính năng thông báo cho từng số ĐT theo danh sách mong muốn.\n" +
      "• Thêm số ĐT vào danh sách nhận thông báo khi Thuê bao trả lời mạng.",
    note:
      "• Mỗi TB được đăng ký tối đa 20 số ĐT nhận thông báo\n" +
      "• SDT: số điện thoại",
  },
  {
    syntax: "TB ON",
    feature:
      "• Đăng ký sử dụng tính năng.\n" +
      "• Kích hoạt tính năng gửi thông báo cho tất cả các số gọi đến lúc Thuê bao tắt máy sau đó trả lời mạng.",
    note: "",
  },
  {
    syntax: "TB OFF",
    feature: "Hủy sử dụng tính năng thông báo trở lại mạng.",
    note: "",
  },
  {
    syntax: "Xóa <SDT1> <SDT2> <SDT3>",
    feature: "Xóa số ĐT khỏi danh sách nhận thông báo.",
    note: "• SDT: số điện thoại",
  },
  {
    syntax: "XOA DS",
    feature:
      "• Xóa toàn bộ danh sách các số ĐT nhận thông báo.\n" +
      "• Hủy đăng ký sử dụng tính năng.",
    note: "",
  },
  {
    syntax: "DS",
    feature: "Kiểm tra danh sách các số ĐT nhận thông báo.",
    note: "",
  },
  {
    syntax: "TB DS",
    feature:
      "Bật chức năng thông báo cho danh sách thuê bao theo danh sách.",
    note: "",
  },
];

  return (
    <div className="w-full px-4 lg:px-0 lg:w-4/5 mx-auto py-4">
      <h1 className="font-bold text-base lg:text-[30px] text-[#1F7ED0] lg:mb-6 lg:mt-12 text-center lg:text-left">
        HƯỚNG DẪN SỬ DỤNG
      </h1>

      <div className="flex flex-col lg:gap-6">
        <div className={`p-2 lg:bg-[#D9D9D9] rounded-[10px]`}>
          <div
            className={`relative rounded-[10px] lg:border-2 lg:border-[#1F7ED0] py-4  h-full  flex flex-col  bg-white`}
          >
            <div
              className="relative overflow-hidden
      flex flex-row gap-4 py-2 items-center px-4
      bg-[linear-gradient(89.99deg,_#3CD39C_36.54%,_#1F7ED0_99.99%)]"
            >
              <div
                className="absolute top-0 right-0 h-full w-10
        bg-[linear-gradient(134.3deg,_#42DDA5_49.75%,_#1679CF_99.48%)]
        [clip-path:polygon(100%_0,_0_0,_100%_100%)]"
              />

              <h3 className="text-white text-base lg:text-[22px] font-bold text-left lg:text-center relative z-10">
                1. Tính năng thông báo trở lại mạng (Notify) cho người gọi.
              </h3>
            </div>

            <div className="py-4 lg:px-4 text-sm">
              <ul className="list-disc list-inside space-y-2">
                <li>
                  Mô tả tính năng: Khi thuê bao A thực hiện cuộc gọi tới thuê
                  bao B (thuê bao sử dụng dịch vụ MCA) mà thuê bao B tắt máy
                  hoặc ngoài vùng phủ sóng… thì sau khi thuê bao B bật máy, trở
                  lại mạng thì hệ thống MCA sẽ có tin nhắn thông báo cho thuê
                  bao A biết là thuê bao B đã kết nối trở lại mạng và có thể
                  liên lạc được.
                </li>
                <li>
                  Các trường hợp thực hiện cuộc gọi không thành công được quy
                  định như sau:
                  <br />
                  + Trường hợp thuê bao tắt máy/hết pin;
                  <br />
                  + Trường hợp thuê bao ngoài vùng phủ sóng.
                </li>
                <li>
                  Sử dụng tính năng qua cú pháp tin nhắn SMS: Khách hàng soạn
                  tin nhắn theo cú pháp và gửi đến đầu số 1020.
                </li>
              </ul>
              <div className="overflow-x-auto mt-2 hidden lg:block">
                <table className="min-w-full border border-gray-300 text-sm">
                  <thead>
                    <tr className="bg-blue-100 text-left">
                      <th className="border border-gray-300 px-3 py-2  text-center">
                        TT
                      </th>
                      <th className="border border-gray-300 px-3 py-2 ">
                        Cú pháp
                      </th>
                      <th className="border border-gray-300 px-3 py-2">
                        Tính năng
                      </th>
                      <th className="border border-gray-300 px-3 py-2 ">
                        Chú thích
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td className="border px-3 py-2 text-center">1</td>
                      <td className="border px-3 py-2 text-pink-600 font-semibold">
                        TB &lt;SDT1&gt; &lt;SDT2&gt;…
                      </td>
                      <td className="border px-3 py-2">
                        • Đăng ký để sử dụng tính năng thông báo cho từng số ĐT
                        theo danh sách mong muốn.
                        <br />• Thêm số ĐT vào danh sách nhận thông báo khi Thuê
                        bao trả lời mạng.
                      </td>
                      <td className="border px-3 py-2">
                        • Mỗi TB được đăng ký tối đa 20 số ĐT nhận thông báo
                        <br />• SDT: số điện thoại
                      </td>
                    </tr>

                    <tr>
                      <td className="border px-3 py-2 text-center">2</td>
                      <td className="border px-3 py-2 text-pink-600 font-semibold">
                        TB ON
                      </td>
                      <td className="border px-3 py-2">
                        • Đăng ký sử dụng tính năng.
                        <br />• Kích hoạt tính năng gửi thông báo cho tất cả các
                        số gọi đến lúc Thuê bao tắt máy sau đó trả lời mạng.
                      </td>
                      <td className="border px-3 py-2"></td>
                    </tr>

                    <tr>
                      <td className="border px-3 py-2 text-center">3</td>
                      <td className="border px-3 py-2 text-pink-600 font-semibold">
                        TB OFF
                      </td>
                      <td className="border px-3 py-2">
                        Hủy sử dụng tính năng thông báo trở lại mạng.
                      </td>
                      <td className="border px-3 py-2"></td>
                    </tr>

                    <tr>
                      <td className="border px-3 py-2 text-center">4</td>
                      <td className="border px-3 py-2 text-pink-600 font-semibold">
                        Xóa &lt;SDT1&gt; &lt;SDT2&gt; &lt;SDT3&gt;
                      </td>
                      <td className="border px-3 py-2">
                        Xóa số ĐT khỏi danh sách nhận thông báo.
                      </td>
                      <td className="border px-3 py-2">• SDT: số điện thoại</td>
                    </tr>

                    <tr>
                      <td className="border px-3 py-2 text-center">5</td>
                      <td className="border px-3 py-2 text-pink-600 font-semibold">
                        XOA DS
                      </td>
                      <td className="border px-3 py-2">
                        • Xóa toàn bộ danh sách các số ĐT nhận thông báo.
                        <br />• Hủy đăng ký sử dụng tính năng.
                      </td>
                      <td className="border px-3 py-2"></td>
                    </tr>

                    <tr>
                      <td className="border px-3 py-2 text-center">6</td>
                      <td className="border px-3 py-2 text-pink-600 font-semibold">
                        DS
                      </td>
                      <td className="border px-3 py-2">
                        Kiểm tra danh sách các số ĐT nhận thông báo.
                      </td>
                      <td className="border px-3 py-2"></td>
                    </tr>

                    <tr>
                      <td className="border px-3 py-2 text-center">7</td>
                      <td className="border px-3 py-2 text-pink-600 font-semibold">
                        TB DS
                      </td>
                      <td className="border px-3 py-2">
                        Bật chức năng thông báo cho danh sách thuê bao theo danh
                        sách.
                      </td>
                      <td className="border px-3 py-2"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="lg:hidden  mt-3">
  {data.map((item, index) => (
    <div
      key={index}
      className="last:border-b-2 last:border-b-[#1F7ED0] rounded overflow-hidden"
    >
      {/* HEADER */}
      <div className="flex bg-[#E5E5E5]">
        <div className="w-10 bg-[linear-gradient(180deg,_#42DDA5_0%,_#1F7ED0_100%)] text-white flex items-center justify-center font-bold">
          {index + 1}
        </div>

        <div className="px-3 py-2.5 text-[15px]">
          Cú pháp:{" "}
          <span className="text-[#E91E8C] font-bold">
            {item.syntax}
          </span>
        </div>
      </div>

      {/* BODY */}
      <div className="border-x-2 border-x-[#1F7ED0] ">
        <div className="bg-white divide-y divide-gray-200 ml-10">
          <div className="px-3 py-3 text-[15px]">
            <span className="text-[#34404B]">Tính năng:</span>
            <div className="mt-1 text-[#34404B] whitespace-pre-line">
              {item.feature}
            </div>
          </div>

          {item.note && (
            <div className="px-3 py-3 text-[15px]">
              <span className="text-[#34404B]">Chú thích:</span>
              <div className="mt-1 text-[#34404B] whitespace-pre-line">
                {item.note}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  ))}
</div>

            </div>
          </div>
        </div>
        <div className={`p-2 lg:bg-[#D9D9D9] rounded-[10px]`}>
          <div
            className={`relative rounded-[10px] lg:border-2 lg:border-[#1F7ED0] py-4  h-full  flex flex-col bg-white`}
          >
            <div
              className="relative overflow-hidden
      flex flex-row gap-4 py-2 items-center px-4
      bg-[linear-gradient(89.99deg,_#3CD39C_36.54%,_#1F7ED0_99.99%)]"
            >
              <div
                className="absolute top-0 right-0 h-full w-10
        bg-[linear-gradient(134.3deg,_#42DDA5_49.75%,_#1679CF_99.48%)]
        [clip-path:polygon(100%_0,_0_0,_100%_100%)]"
              />

              <h3 className="text-white text-base  lg:text-[22px] font-bold text-left lg:text-center relative z-10">
                2.  Tính năng thông báo cuộc gọi nhỡ qua thư điện tử.
              </h3>
            </div>

            <div className="p-4 text-sm">
              <p>
                Tính năng thông báo qua thư điện tử sẽ giúp các khách hàng sử
                dụng dịch vụ MCA có nhiều sự lựa chọn để thông báo cho mình biết
                về thông tin các cuộc gọi nhỡ. Đặc biệt trong trường hợp các
                Khách hàng có những chuyến công tác xa, nước ngoài…  nhưng vẫn
                có thể biết được thông tin những người gọi đến trong thời gian
                tắt máy.
              </p>
              <p className="mt-4 font-semibold">
                Đăng ký Email nhận thông báo cuộc gọi nhỡ qua tin nhắn SMS:
              </p>
              <p>Các bước đăng ký Email nhận Thông báo cuộc gọi nhỡ:</p>
              <ul className="list-disc list-inside space-y-2">
                <li>
                  Bước 1: Soạn tin EM{" "}
                  <span className="font-semibold text-[#EF1C91]">
                    &lt;ĐỊA CHỈ EMAIL&gt;
                  </span>{" "}
                  gửi <span className="font-semibold text-[#EF1C91]">1020</span>
                </li>

                <li>
                  Bước 2: Hệ thống sẽ gửi tin nhắn có chứa mã xác nhận cho Khách
                  hàng.
                </li>

                <li>
                  Bước 3: Để hoàn tất quá trình đăng ký, Khách hàng gửi tin nhắn
                  xác nhận Email theo cú pháp:
                  <span className="font-semibold text-[#EF1C91]">
                    {" "}
                    XN &lt;MÃ XÁC NHẬN&gt;{" "}
                  </span>{" "}
                  gửi <span className="font-semibold text-[#EF1C91]">1020</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className={`p-2 lg:bg-[#D9D9D9] rounded-[10px]`}>
          <div
            className={`relative rounded-[10px] lg:border-2 lg:border-[#1F7ED0] py-4  h-full  flex flex-col bg-white`}
          >
            <div
              className="relative overflow-hidden
      flex flex-row gap-4 py-2 items-center px-4
      bg-[linear-gradient(89.99deg,_#3CD39C_36.54%,_#1F7ED0_99.99%)]"
            >
              <div
                className="absolute top-0 right-0 h-full w-10
        bg-[linear-gradient(134.3deg,_#42DDA5_49.75%,_#1679CF_99.48%)]
        [clip-path:polygon(100%_0,_0_0,_100%_100%)]"
              />

              <h3 className="text-white text-base lg:text-[22px] font-bold text-left lg:text-center relative z-10">
                3. Cài đặt bản tin trả lời tự động
              </h3>
            </div>

            <div className="p-4 text-sm">
              <p>
                Khách hàng sẽ lựa chọn các mẫu bản tin trả lời tự động do
                VinaPhone cung cấp. Khi đó các thuê bao VinaPhone gọi vào số
                thuê bao của khách hàng trong khoảng thời gian khách hàng tắt
                máy hoặc ngoài vùng phủ sóng sẽ nhận được bản tin trả lời tự
                động của hệ thống theo nội dung mà khách hàng đã cài đặt
              </p>
              <p className="mt-4 font-semibold">
                Các mẫu bản tin trả lời tự động sau:
              </p>
              <ul className="list-decimal list-inside space-y-2">
                <li>Tôi đang bận. Tôi sẽ gọi lại sau.</li>

                <li>Tôi đang đi công tác. Tôi sẽ gọi lại sau.</li>

                <li>Tôi đang họp. Tôi sẽ gọi lại sau.</li>
                <li>Tôi đang trên đường. Tôi sẽ gọi lại sau.</li>
                <li>
                  Điện thoại của tôi đang ngoài vùng phủ sóng. Tôi sẽ gọi lại
                  sau.
                </li>
                <li>Tôi đang tắt máy. Tôi sẽ gọi lại sau.</li>
                <li>Tôi hiện không thể nghe máy. Tôi sẽ gọi lại sau.</li>
              </ul>
              <p>Khách hàng có thể cài đặt bản tin trả lời tự động theo một trong các cách sau:</p>
              <ul className="list-disc list-inside space-y-2">
                <li>
                  <b>Cách 1:</b> Khách hàng soạn tin: {" "}
                  <span className="font-semibold text-[#EF1C91]">
                    &lt;ND_Số thứ tự mẫu bản tin&gt;
                  </span>{" "}
                  gửi đến <span className="font-semibold text-[#EF1C91]">1020</span>. Trong đó:
                  <br/>  + Dấu “_” trong cú pháp tin nhắn tượng trưng cho dấu cách (khoảng trống).
                  <br/>  + Số thứ tự mẫu bản tin là số thứ tự của mẫu bản tin trong danh sách liệt kê trên.
                  <br/>  Ví dụ: Soan ND 1 de cai dat ban tin: “Toi dang ban. Toi se goi lai sau.”
                  
                </li>

                <li>
                  <b>Cách 2:</b> Truy cập vào địa chỉ http://bantinmca.vn/ và làm theo hướng dẫn.
                </li>
              </ul>
              <p className="mt-4 font-semibold">Hủy cài đặt bản tin trả lời tự động:</p>
              <ul className="list-disc list-inside space-y-2">
                <li>
                  <b>Cách 1:</b> Soạn tin: <b>"ND_OFF"</b> gửi đến <b>1020</b> . (Dấu "_" trong cú pháp tin nhắn tượng trưng cho dấu cách (khoảng trống)).
                </li>
                <li><b>Cách 2:</b> Truy cập vào địa chỉ http://bantinmca.vn/ và làm theo hướng dẫn.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className={`p-2 lg:bg-[#D9D9D9] rounded-[10px]`}>
          <div
            className={`relative rounded-[10px] lg:border-2 lg:border-[#1F7ED0] py-4  h-full  flex flex-col bg-white`}
          >
            <div
              className="relative overflow-hidden
      flex flex-row gap-4 py-2 items-center px-4
      bg-[linear-gradient(89.99deg,_#3CD39C_36.54%,_#1F7ED0_99.99%)]"
            >
              <div
                className="absolute top-0 right-0 h-full w-10
        bg-[linear-gradient(134.3deg,_#42DDA5_49.75%,_#1679CF_99.48%)]
        [clip-path:polygon(100%_0,_0_0,_100%_100%)]"
              />

              <h3 className="text-white text-base lg:text-[22px] font-bold text-left lg:text-center relative z-10">
                4. Nhận bản tin thông báo cuộc gọi nhỡ
              </h3>
            </div>

            <div className="p-4 text-sm">
              
              <ul className="list-disc list-inside space-y-2">
                <li>
                  Khách hàng sẽ nhận được bản tin thông báo cuộc gọi nhỡ ngay sau khi bật máy hoặc trở lại vùng phủ sóng.
                </li>

                <li>
                  Khách hàng có thể cài đặt bản tin thông báo cuộc gọi nhỡ theo 2 định dạng thông tin qua SMS ( Dấu "_" trong cú pháp tin nhắn tượng trưng cho dấu cách (khoảng trống)):
                  <br/>+ <b>Cách 1:</b> Định dạng tổng hợp tất cả các cuộc gọi (số thuê bao + số lần gọi), soạn tin: <span className="font-semibold text-[#EF1C91]">MCA_AM</span> gửi <span className="font-semibold text-[#EF1C91]">1020</span>
                  <br/>+ <b>Cách 2:</b> Định dạng chi tiết từng cuộc gọi (số thuê bao + thời gian gọi), soạn tin: <span className="font-semibold text-[#EF1C91]">MCA_UAM</span> gửi <span className="font-semibold text-[#EF1C91]">1020</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
